import { render, staticRenderFns } from "./jbgQrcode.vue?vue&type=template&id=7c8f8ca9&"
import script from "./jbgQrcode.vue?vue&type=script&lang=js&"
export * from "./jbgQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports